import Vue from "vue";
import AddCollection from './AddCollection/AddCollection.vue'; 
import AddFolder from './AddFolder/AddFolder.vue'; 
import AddLink from './AddLink/AddLink.vue'; 
import AddSpace from './AddSpace/AddSpace.vue'; 
import AudioPlayer from './AudioPlayer/AudioPlayer.vue'; 
import BottomButtons from './BottomButtons/BottomButtons.vue'; 
import Branding from './Branding/Branding.vue'; 
import Collect from './Collect/Collect.vue'; 
import CollectionChoose from './CollectionChoose/CollectionChoose.vue'; 
import CollectionList from './CollectionList/CollectionList.vue'; 
import CollectionSelect from './CollectionSelect/CollectionSelect.vue'; 
import CollectionSucces from './CollectionSucces/CollectionSucces.vue'; 
import CollectionTree from './CollectionTree/CollectionTree.vue'; 
import ColorPicker from './ColorPicker/ColorPicker.vue'; 
import CropControls from './CropControls/CropControls.vue'; 
import Delete from './Delete/Delete.vue'; 
import DesktopFileLegend from './DesktopFileLegend/DesktopFileLegend.vue'; 
import DesktopFileList from './DesktopFileList/DesktopFileList.vue'; 
import DesktopFilePlaceholders from './DesktopFilePlaceholders/DesktopFilePlaceholders.vue'; 
import DesktopSpaceItem from './DesktopSpaceItem/DesktopSpaceItem.vue'; 
import DownloadItems from './DownloadItems/DownloadItems.vue'; 
import ExtensionPreview from './ExtensionPreview/ExtensionPreview.vue'; 
import Faces from './Faces/Faces.vue'; 
import FacesOverlay from './FacesOverlay/FacesOverlay.vue'; 
import FigmaPreview from './FigmaPreview/FigmaPreview.vue'; 
import File from './File/File.vue'; 
import FileActions from './FileActions/FileActions.vue'; 
import FileDetail from './FileDetail/FileDetail.vue'; 
import FileDetailsList from './FileDetailsList/FileDetailsList.vue'; 
import FileEditorTransforms from './FileEditorTransforms/FileEditorTransforms.vue'; 
import FileList from './FileList/FileList.vue'; 
import FilePreview from './FilePreview/FilePreview.vue'; 
import FileSortSettings from './FileSortSettings/FileSortSettings.vue'; 
import FileUpload from './FileUpload/FileUpload.vue'; 
import FolderInputForm from './FolderInputForm/FolderInputForm.vue'; 
import ImageDimensions from './ImageDimensions/ImageDimensions.vue'; 
import ImagePreview from './ImagePreview/ImagePreview.vue'; 
import InfoTabs from './InfoTabs/InfoTabs.vue'; 
import ItemActions from './ItemActions/ItemActions.vue'; 
import LoginForm from './LoginForm/LoginForm.vue'; 
import LoginNavigation from './LoginNavigation/LoginNavigation.vue'; 
import MessageOverlay from './MessageOverlay/MessageOverlay.vue'; 
import MobileLoginForm from './MobileLoginForm/MobileLoginForm.vue'; 
import MobileMenu from './MobileMenu/MobileMenu.vue'; 
import MobilePasswordResetForm from './MobilePasswordResetForm/MobilePasswordResetForm.vue'; 
import MobileSnackbar from './MobileSnackbar/MobileSnackbar.vue'; 
import MobileTopNav from './MobileTopNav/MobileTopNav.vue'; 
import MobileUserForgotForm from './MobileUserForgotForm/MobileUserForgotForm.vue'; 
import More from './More/More.vue'; 
import Move from './Move/Move.vue'; 
import NavigationSidebar from './NavigationSidebar/NavigationSidebar.vue'; 
import NotificationsMenu from './NotificationsMenu/NotificationsMenu.vue'; 
import Notify from './Notify/Notify.vue'; 
import OptionButtons from './OptionButtons/OptionButtons.vue'; 
import PdfPreview from './PdfPreview/PdfPreview.vue'; 
import PsdPreview from './PsdPreview/PsdPreview.vue'; 
import PwaForm from './PwaForm/PwaForm.vue'; 
import Rename from './Rename/Rename.vue'; 
import Replace from './Replace/Replace.vue'; 
import RoleAdd from './RoleAdd/RoleAdd.vue'; 
import RoleDelete from './RoleDelete/RoleDelete.vue'; 
import RoleEdit from './RoleEdit/RoleEdit.vue'; 
import Search from './Search/Search.vue'; 
import SearchList from './SearchList/SearchList.vue'; 
import SearchResults from './SearchResults/SearchResults.vue'; 
import SectionBox from './SectionBox/SectionBox.vue'; 
import Snackbar from './Snackbar/Snackbar.vue'; 
import SpaceItem from './SpaceItem/SpaceItem.vue'; 
import Storage from './Storage/Storage.vue'; 
import TagHolder from './TagHolder/TagHolder.vue'; 
import TopActions from './TopActions/TopActions.vue'; 
import TopOptions from './TopOptions/TopOptions.vue'; 
import Transfer from './Transfer/Transfer.vue'; 
import Tree from './Tree/Tree.vue'; 
import UserAdd from './UserAdd/UserAdd.vue'; 
import UserDelete from './UserDelete/UserDelete.vue'; 
import UserMenu from './UserMenu/UserMenu.vue'; 
import UsersByRole from './UsersByRole/UsersByRole.vue'; 
import UserUpdate from './UserUpdate/UserUpdate.vue'; 
import VideoPreview from './VideoPreview/VideoPreview.vue'; 


const importAllVue = () => {
	Vue.component("add-collection", AddCollection); 
	Vue.component("add-folder", AddFolder); 
	Vue.component("add-link", AddLink); 
	Vue.component("add-space", AddSpace); 
	Vue.component("audio-player", AudioPlayer); 
	Vue.component("bottom-buttons", BottomButtons); 
	Vue.component("branding", Branding); 
	Vue.component("collect", Collect); 
	Vue.component("collection-choose", CollectionChoose); 
	Vue.component("collection-list", CollectionList); 
	Vue.component("collection-select", CollectionSelect); 
	Vue.component("collection-succes", CollectionSucces); 
	Vue.component("collection-tree", CollectionTree); 
	Vue.component("color-picker", ColorPicker); 
	Vue.component("crop-controls", CropControls); 
	Vue.component("delete", Delete); 
	Vue.component("desktop-file-legend", DesktopFileLegend); 
	Vue.component("desktop-file-list", DesktopFileList); 
	Vue.component("desktop-file-placeholders", DesktopFilePlaceholders); 
	Vue.component("desktop-space-item", DesktopSpaceItem); 
	Vue.component("download-items", DownloadItems); 
	Vue.component("extension-preview", ExtensionPreview); 
	Vue.component("faces", Faces); 
	Vue.component("faces-overlay", FacesOverlay); 
	Vue.component("figma-preview", FigmaPreview); 
	Vue.component("file", File); 
	Vue.component("file-actions", FileActions); 
	Vue.component("file-detail", FileDetail); 
	Vue.component("file-details-list", FileDetailsList); 
	Vue.component("file-editor-transforms", FileEditorTransforms); 
	Vue.component("file-list", FileList); 
	Vue.component("file-preview", FilePreview); 
	Vue.component("file-sort-settings", FileSortSettings); 
	Vue.component("file-upload", FileUpload); 
	Vue.component("folder-input-form", FolderInputForm); 
	Vue.component("image-dimensions", ImageDimensions); 
	Vue.component("image-preview", ImagePreview); 
	Vue.component("info-tabs", InfoTabs); 
	Vue.component("item-actions", ItemActions); 
	Vue.component("login-form", LoginForm); 
	Vue.component("login-navigation", LoginNavigation); 
	Vue.component("message-overlay", MessageOverlay); 
	Vue.component("mobile-login-form", MobileLoginForm); 
	Vue.component("mobile-menu", MobileMenu); 
	Vue.component("mobile-password-reset-form", MobilePasswordResetForm); 
	Vue.component("mobile-snackbar", MobileSnackbar); 
	Vue.component("mobile-top-nav", MobileTopNav); 
	Vue.component("mobile-user-forgot-form", MobileUserForgotForm); 
	Vue.component("more", More); 
	Vue.component("move", Move); 
	Vue.component("navigation-sidebar", NavigationSidebar); 
	Vue.component("notifications-menu", NotificationsMenu); 
	Vue.component("notify", Notify); 
	Vue.component("option-buttons", OptionButtons); 
	Vue.component("pdf-preview", PdfPreview); 
	Vue.component("psd-preview", PsdPreview); 
	Vue.component("pwa-form", PwaForm); 
	Vue.component("rename", Rename); 
	Vue.component("replace", Replace); 
	Vue.component("role-add", RoleAdd); 
	Vue.component("role-delete", RoleDelete); 
	Vue.component("role-edit", RoleEdit); 
	Vue.component("search", Search); 
	Vue.component("search-list", SearchList); 
	Vue.component("search-results", SearchResults); 
	Vue.component("section-box", SectionBox); 
	Vue.component("snackbar", Snackbar); 
	Vue.component("space-item", SpaceItem); 
	Vue.component("storage", Storage); 
	Vue.component("tag-holder", TagHolder); 
	Vue.component("top-actions", TopActions); 
	Vue.component("top-options", TopOptions); 
	Vue.component("transfer", Transfer); 
	Vue.component("tree", Tree); 
	Vue.component("user-add", UserAdd); 
	Vue.component("user-delete", UserDelete); 
	Vue.component("user-menu", UserMenu); 
	Vue.component("users-by-role", UsersByRole); 
	Vue.component("user-update", UserUpdate); 
	Vue.component("video-preview", VideoPreview); 

};

export default importAllVue;
